module.exports = __webpack_public_path__ + "static/project-hermods.c33ac9e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/project-hermods.jpg
// module id = 450
// module chunks = 35783957827783